import axios from 'axios';
import store from '@/store';
import Cookies from 'js-cookie';

// Use VUE_APP_BASE_URL for both production and development
const baseURL = process.env.VUE_APP_BASE_URL;

const axiosApi = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    withCredentials: true
  });

// Response interceptor to handle deleted users globally
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the error indicates a deleted user
    if (error.response) {
      const status = error.response.status;
      const message = error.response.data?.message || '';
      const requestUrl = error.config?.url || '';
      
      // Check for user deletion scenarios
      // Look for 404s from user-specific endpoints or specific error messages
      const isUserNotFound = (
        (status === 404 && requestUrl.includes('/users/')) ||
        (status === 401 && message.toLowerCase().includes('user not found')) ||
        (status === 401 && message.toLowerCase().includes('user deleted')) ||
        (status === 401 && message.toLowerCase().includes('account deleted'))
      );
      
      if (isUserNotFound) {
        // Clear all authentication data
        store.commit('clearAuthData');
        
        // Clear all cookies
        Cookies.remove("token", { path: '/', domain: window.location.hostname });
        Cookies.remove("user-entidade", { path: '/', domain: window.location.hostname });
        Cookies.remove("token");
        Cookies.remove("user-entidade");
        
        // Clear localStorage and sessionStorage as well
        localStorage.clear();
        sessionStorage.clear();
        
        // Show toast notification
        store.dispatch('showToast', {
          title: 'Sessão Encerrada',
          message: 'Sua conta foi removida do sistema. Entre em contato com o administrador.',
          type: 'toast-danger',
          headerClass: 'toast-header-danger'
        });
        
        // Force redirect to login with a flag to prevent loops
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
        
        // Create a specific error for deleted users
        const deletedError = new Error("USER_DELETED");
        deletedError.originalError = error;
        return Promise.reject(deletedError);
      }
    }
    
    // For other errors, return the original error
    return Promise.reject(error);
  }
);

export default axiosApi;